import React from "react";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import TranslationViewer from "./TranslationViewer";

function App() {

	const isBrowser = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    return (
      userAgent.includes("chrome") ||
      userAgent.includes("firefox") ||
      userAgent.includes("safari") ||
      userAgent.includes("edge") ||
      userAgent.includes("opera")
    );
  };

  console.log("UserAgent: ", isBrowser())
  return (
    <div className="App">
       <Router>
      <Routes>
         {isBrowser() ? (
          <Route path="/translate/:id" element={<TranslationViewer />} />
        ) : (
          <Route path="/ebhasha/:id" element={<TranslationViewer />} />
        )}
        <Route path="/" element={<TranslationViewer />} />
        <Route path="/ebhasha/:id" element={<TranslationViewer />} />
      </Routes>
    </Router>
    </div>
  );
}

export default App;

